import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToasterService } from '@lib/components/toaster/toaster.service';
import { AuthService } from '@lib/services';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * Interceptor that handles server errors.
 *
 * @param request The request object.
 * @param next The next interceptor in the chain.
 *
 * @returns The next Observable.
 */
export const serverErrorInterceptor: HttpInterceptorFn = (request, next) => {
    const router = inject(Router);
    const authService = inject(AuthService);
    const toasterService = inject(ToasterService);

    return next(request).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === HttpStatusCode.Unauthorized) {
                authService.logout();
                router.navigateByUrl('/auth/login');
            }
            toasterService.show({
                message: error.error?.errors?.[0]?.message ?? error.message ?? 'Something went wrong!',
                status: 'error',
            });
            return throwError(() => error);
        }),
    );
};
